<template>
  <v-container pa-0 fluid>
    <v-row no-gutters>
      <v-col cols="12">
        <v-row justify="center" align="center" no-gutters style="height: 100vh">
          <div class="text-center py-10">
            <v-icon size="100" color="accent">mdi mdi-circle-off-outline</v-icon>
            <div class="headline font-weight-bold mt-5 mb-5">{{ $t('no_permissions_view.title') }}</div>
            <div class="subtitle-1">{{ $t('no_permissions_view.description') }}</div>
          </div>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'NoPermissionsView',
};
</script>

<style scoped></style>
